import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import {
  SupressionRuleWrapper,
  SupressionRuleBreadcrumbContainer,
  ContentContainer,
} from "./SupressionRule.styled";
import DynamicBreadcrumbs from "../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs";
import { CreateMessageSuppression, EmptyMessagesSuppression, SuppressionRulesTable } from "./pages";

const SupressionRule = () => {
  const location = useLocation();

  const breadcrumbItems = [
    { label: "Home", path: "/v2/home" },
    { label: "Suppression Rules", path: "/v2/suppression-rules" },
  ];

  return (
    <SupressionRuleWrapper>
      <SupressionRuleBreadcrumbContainer>
        <DynamicBreadcrumbs
          items={breadcrumbItems}
          currentPath={location.pathname}
        />
      </SupressionRuleBreadcrumbContainer>
      <ContentContainer>
        <Routes>
          <Route index element={<EmptyMessagesSuppression />} />
          <Route path="create" element={<CreateMessageSuppression />} />
          <Route path="list" element={<SuppressionRulesTable />} />
        </Routes>
      </ContentContainer>
    </SupressionRuleWrapper>
  );
};

export default SupressionRule;
